import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.5rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.gray8};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2rem 2rem 1.5rem 2rem;
  }

  & > div {
    @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
      width: 36%;
    }

    &.customer-order {
      width: 100%;
      margin-bottom: 0.5rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
        width: 25%;
        margin-bottom: unset;
      }

      & > h4 {
        font-weight: bold;
        font-size: 0.875rem;
      }
    }
  }
`;
